import { isCollectionOperation, mutationOperationIdentifier } from "@mdbase-dev/connect-protocol";
import { parseStored } from "./runtime-utils.js";
export class PendingMutationStore {
    storage;
    baseKey;
    constructor(storage, baseKey) {
        this.storage = storage;
        this.baseKey = baseKey;
    }
    list(collectionId) {
        if (!collectionId)
            return [];
        const legacy = parseStored(this.storage.getItem(this.baseKey));
        if (validPendingMutation(legacy) && legacy.collectionId === collectionId) {
            const migratedKey = this.key(legacy.requestId);
            if (!this.storage.getItem(migratedKey)) {
                this.storage.setItem(migratedKey, JSON.stringify(legacy));
            }
            this.storage.removeItem(this.baseKey);
        }
        const keys = [];
        for (let index = 0; index < this.storage.length; index += 1) {
            const key = this.storage.key(index);
            if (key?.startsWith(`${this.baseKey}:`))
                keys.push(key);
        }
        return keys
            .map((key) => parseStored(this.storage.getItem(key)))
            .filter((pending) => validPendingMutation(pending) && pending.collectionId === collectionId)
            .sort((left, right) => left.createdAt - right.createdAt
            || left.requestId.localeCompare(right.requestId));
    }
    find(collectionId, requestId) {
        return this.list(collectionId)
            .find((pending) => pending.requestId === requestId) ?? null;
    }
    identifier(pending) {
        return pending.mutation ?? mutationOperationIdentifier(pending.operation, pending.request?.input ?? (pending.operation === "sync" ? { action: "mutate" } : {})) ?? (pending.operation === "sync" ? "sync:mutate" : pending.operation);
    }
    store(pending) {
        this.storage.setItem(this.key(pending.requestId), JSON.stringify(pending));
    }
    take(requestId) {
        const key = this.key(requestId);
        const pending = parseStored(this.storage.getItem(key));
        this.storage.removeItem(key);
        return pending;
    }
    key(requestId) {
        return `${this.baseKey}:${encodeURIComponent(requestId)}`;
    }
}
function validPendingMutation(pending) {
    return Boolean(pending
        && typeof pending.collectionId === "string"
        && typeof pending.requestId === "string"
        && pending.requestId.length > 0
        && isCollectionOperation(pending.operation)
        && typeof pending.inputFingerprint === "string"
        && Number.isFinite(pending.createdAt)
        && pending.createdAt > 0
        && (pending.envelope || pending.request)
        && (pending.operation === "sync" || mutationOperationIdentifier(pending.operation, pending.request?.input ?? {}) !== null));
}
